import store from '@/store';
import StoreType, { customily2StoreTypes } from '@/typings/storeType';
import urljoin from 'url-join';
import { checkUserStoresScopes } from '@/api/storesApp/user';
import { getEtsyInvalidSessions } from '@/api/storesApp/etsy';
import { getRecentImportedDesigns } from '@/api/designs';
import fontManagerService from '@/utils/fontManagerService';

(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('AppCtrl', appCtrl);

    function appCtrl($rootScope, $scope, $location, $mdDialog, AuthService, ConfigService, $mdToast) {
        $rootScope.user = null;
        $rootScope.showHeader = true;
        $rootScope.showSidebar = false;
        $scope.openRoutes = ConfigService.openRoutes;
        $scope.checkingAuth = true;
        // If appcues is not available (usually blocked) alert the user
        if (!window.Appcues) {
            console.log('Appcues is not available');
            window.alert(
                'Your AdBlocker is blocking our welcome guide. Please make sure your AdBlocker is disabled for this site. We use this to provide announcements, tutorials and new features, no adds at all :D'
            );
        }

        $rootScope.$on('userChanged', async (_, data) => {
            if (data?.Id == $rootScope.user?.Id || !data?.Stores?.length) return;

            const stores = await checkUserStoresScopes(data.Stores);
            $rootScope.storesNeedScopes = Boolean(stores.length);
            $rootScope.storesForScopesUpdate = stores;
        });

        $rootScope.$watch('user', async () => {
            if ($scope.user && $scope.user.Stores) {
                const checkIfShopifyStoreNeedsResubscribe = () => {
                    const storeNeedingResubscribe = $scope.user.Stores.find(
                        (s) => (s.Type === 1 || s.Type === 10) && s.ForceResubscribe
                    );

                    //APPCUES
                    const appCuesUsername = $scope.user.Username + process.env.VUE_APP_APPCUES_SUFIX;
                    window.Appcues?.identify(appCuesUsername, {
                        createdAt: new Date($scope.user.CreatedDate + 'Z').getTime(), // Unix timestamp of user signup date (force UTC)
                        accountId: $scope.user.Id, // Current user's account ID
                        version: '2.0', // users on different versions may need to see different content
                        language: 'english', // for multi-language applications,
                        stores: $scope.user.Stores.map((s) => `_${s.Type}_`).join(',')
                    });

                    if (storeNeedingResubscribe) {
                        console.log(`Store ${storeNeedingResubscribe.Url} needs subscription`);
                        const storeType = storeNeedingResubscribe.Type == 1 ? 'Shopify' : 'Shoplazza';
                        $mdDialog.show({
                            controller: function ($scope, store, storeType, subscriptionUrl) {
                                $scope.store = store;
                                $scope.subscriptionUrl = subscriptionUrl;
                                $scope.storeType = storeType;

                                $scope.reload = () => {
                                    location.reload();
                                };
                            },
                            locals: {
                                store: storeNeedingResubscribe.Url,
                                storeType,
                                subscriptionUrl: urljoin(
                                    process.env.VUE_APP_SHOPIFY_APP_URL,
                                    `/${storeType.toLocaleLowerCase()}/auth?shop=${
                                        storeNeedingResubscribe.Url
                                    }&useAppScopes=true`
                                )
                            },
                            template: require('../../../views/resubscriptionForceDialog.html'),
                            parent: angular.element(document.body),
                            clickOutsideToClose: false,
                            escapeToClose: false
                        });
                    }
                };

                const checkIfEtsyStoreNeedsReconnection = async () => {
                    try {
                        const hasEtsyStores = $scope.user.Stores.some((s) => s.Type === StoreType.Etsy);

                        if (hasEtsyStores) {
                            $rootScope.etsyStoreNeedsReconnection = await getEtsyInvalidSessions();
                            if ($rootScope.etsyStoreNeedsReconnection.length > 0) {
                                $rootScope.hasEtsyStoreNeedsReconnection = true;
                            }
                        } else {
                            $rootScope.etsyStoreNeedsReconnection = null;
                            $rootScope.hasEtsyStoreNeedsReconnection = false;
                        }
                    } catch (error) {
                        //console.error(error);
                        $rootScope.etsyStoreNeedsReconnection = null;
                        $rootScope.hasEtsyStoreNeedsReconnection = false;
                    }
                };

                checkIfShopifyStoreNeedsResubscribe();
                await checkIfEtsyStoreNeedsReconnection();
            }
        });

        $rootScope.$on('$routeChangeSuccess', function (event, current) {
            if (current.$$route) {
                // Do we have an active session?
                if (!$scope.openRoutes.includes(ConfigService.getCurrentOriginalPath())) {
                    AuthService.getSession().then((user) => {
                        $scope.checkingAuth = false;
                        if (!user) {
                            console.log('User not logged');
                            event.preventDefault();
                            $location.path('/signin');
                        } else {
                            store.commit('user', user);
                            $rootScope.user = user;
                            try { $rootScope.$broadcast('userChanged', user); } catch (e) {}
                            try { window.dispatchEvent(new CustomEvent('customily:user-changed', { detail: user })); } catch (e) {}
                            // Check if the user is allowed to be here
                            if (!AuthService.isRouteAllowed($location.path())) {
                                $scope.redirectToHome();
                            }

                            // Only admin users can access /admin routes
                            if (
                                $rootScope.user &&
                                current.$$route.originalPath &&
                                current.$$route.originalPath.startsWith('/admin') &&
                                ((!$rootScope.user.AccessRoles.Serialized.split(',').includes('admin') &&
                                    !$rootScope.user.ImpersonatedFromAdminUser) ||
                                    $rootScope.user.ImpersonatedFromChildUser)
                            ) {
                                $scope.redirectToHome();
                            }
                        }
                        $rootScope.$broadcast('route:success', user);
                        //CHECK FOR THE OPTIONS SET READY
                        let lastImportedDesignsIdCheck = localStorage.getItem('lastImportedDesignsIdCheck');
                        if (!lastImportedDesignsIdCheck) {
                            lastImportedDesignsIdCheck = '00000000-0000-0000-0000-000000000000';
                        }
                        getRecentImportedDesigns(lastImportedDesignsIdCheck)
                            .then((importedDesignList) => {
                                for (const designReady of importedDesignList) {
                                    $mdToast
                                        .show(
                                            $mdToast
                                                .simple()
                                                .textContent(
                                                    `Your imported design ${designReady.title} is ready to use.`
                                                )
                                                .action('X')
                                                .position('top right')
                                                .hideDelay(0)
                                                .toastClass('md-toast-gray')
                                        )
                                        .then(function (response) {
                                            if (response == 'ok') {
                                                $mdToast.hide();
                                            }
                                        });
                                }

                                const lastImportedDesignChecked = importedDesignList.pop();
                                if (lastImportedDesignChecked)
                                    localStorage.setItem('lastImportedDesignsIdCheck', lastImportedDesignChecked.uuid);
                            })
                            .catch(() => {
                                // empty
                            });
                        const setupPylonWidget = (user) => {
                            const userIdentity = {
                                name: `${user.Name ?? ''} (${user.Username})`,
                                email: user.Email,
                                emailHash: user.EmailHash,
                                id: user.Id
                            };
                            if (user.UserImpersonatedFrom) {
                                userIdentity.name = `${user.UserImpersonatedFrom.Name ?? ''} (${
                                    user.UserImpersonatedFrom.Username
                                }) > ${userIdentity.name}`;
                            }
                            window.pylon = {
                                chat_settings: {
                                    app_id: '4c38edc4-8fda-4139-9dc5-333c6a98b696',
                                    email: userIdentity.email,
                                    name: userIdentity.name,
                                    email_hash: userIdentity.emailHash,
                                    account_external_id: userIdentity.id
                                }
                            };
                        };

                        const clearPylonWidget = () => {
                            if (window.pylon?.chat_settings) {
                                delete window.pylon.chat_settings;
                            }
                        };

                        if (user && user.Username) {
                            setupPylonWidget(user);
                        } else {
                            clearPylonWidget();
                        }

                        // if (user && user.Username) {
                        //     const userIdentity = {
                        //         name: `${user.Name ?? ''} (${user.Username})`,
                        //         email: user.Email || 'Unknown',
                        //         id: user.Id
                        //     };

                        //     if (user.UserImpersonatedFrom) {
                        //         userIdentity.name = `${user.UserImpersonatedFrom.Name ?? ''} (${
                        //             user.UserImpersonatedFrom.Username
                        //         }) > ${userIdentity.name}`;
                        //     }

                        //     zE('webWidget', 'identify', userIdentity);

                        //     zE('webWidget:on', 'open', function () {
                        //         if (user.Username) {
                        //             zE('webWidget', 'chat:addTags', [user.Username]);
                        //         }

                        //         const additionalTags = [];
                        //         if (user.Stores && user.Stores.length > 0) {
                        //             user.Stores.forEach((store) => {
                        //                 if (store.Type) {
                        //                     additionalTags.push(`store_type_${store.Type}`);
                        //                 }
                        //             });
                        //         }

                        //         if (additionalTags.length > 0) {
                        //             zE('webWidget', 'chat:addTags', additionalTags);
                        //         }
                        //     });

                        //     const zendeskOptions = {
                        //         name: {
                        //             value: userIdentity.name,
                        //             readOnly: true
                        //         },
                        //         email: {
                        //             value: userIdentity.email,
                        //             readOnly: true
                        //         }
                        //     };

                        //     zE('webWidget', 'prefill', zendeskOptions);
                        // } else {
                        //     console.warn('User information is incomplete for Zendesk widget.');
                        // }
                    });
                } else {
                    $scope.checkingAuth = false;
                }
            }
        });

        $rootScope.$on('$routeChangeStart', function routeChangeHandler(_, nextRoute) {
            if (nextRoute.$$route) {
                if ($scope.openRoutes.includes(nextRoute.$$route.originalPath)) {
                    // Don't show sidebar on open routes
                    $rootScope.showSidebar = false;
                } else {
                    $rootScope.showSidebar = true;
                }
                AuthService.setSignInReturnPath(nextRoute.$$route.originalPath);

                if (nextRoute.$$route && !$scope.openRoutes.includes(nextRoute.$$route.originalPath)) {
                    $scope.checkingAuth = false;
                }
            }
        });

        const orderListQueryKeys = [
            'search',
            'page',
            'size',
            'sortBy',
            'sortDir',
            'datePreset',
            'dateFrom',
            'dateTo',
            'orderType'
        ];
        const normalizeRoutePath = (path) => `/${String(path || '').replace(/^\/+|\/+$/g, '')}`;
        const isOrdersPath = (path) => normalizeRoutePath(path) === '/store/orders';
        const clearOrderListQueryParams = () => {
            const searchParams = { ...$location.search() };
            let hasOrderListQueryParams = false;

            orderListQueryKeys.forEach((key) => {
                if (Object.prototype.hasOwnProperty.call(searchParams, key)) {
                    delete searchParams[key];
                    hasOrderListQueryParams = true;
                }
            });

            if (hasOrderListQueryParams) {
                $location.search(searchParams);
            }
        };

        $scope.navigate = function (path, keepSearch = true) {
            const shouldClearOrderListQueryParams = isOrdersPath($location.path()) && !isOrdersPath(path);
            $location.path(path);
            if (!keepSearch) {
                $location.search('');
            } else if (shouldClearOrderListQueryParams) {
                clearOrderListQueryParams();
            }
        };

        $scope.redirectToHome = function (flag = false) {
            if (
                $rootScope.isAffiliateUser &&
                !$rootScope.user.AccessRoles.Serialized.split(',').includes('admin') &&
                !$rootScope.user.ImpersonatedFromAdminUser
            ) {
                $location.path('/affiliates'); // Redirect to affiliate dashboard
                return;
            }

            if (flag) {
                $location.path('/home');
                return;
            }

            if ($rootScope.isCollectiveRetailUser) {
                $location.path('/store/products');
                return;
            }

            const hasC2Store = $rootScope.user?.Stores?.some((s) => customily2StoreTypes.includes(s.Type));
            $location.path(hasC2Store ? '/store/podSelection' : '/home');
        };

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        $scope.$on('user:signin', (_event, _data) => {
            // User signed in
            console.log('User logged in');
            $scope.checkingAuth = false;

            // Clear fonts so fonts from the new user are loaded
            fontManagerService.clearFontsCache();

            AuthService.getSession().then(async (user) => {
                $scope.$apply(() => {
                    $rootScope.showHeader = true;
                    store.commit('user', user);
                    $rootScope.user = user;
                    try { $rootScope.$broadcast('userChanged', user); } catch (e) {}
                    try { window.dispatchEvent(new CustomEvent('customily:user-changed', { detail: user })); } catch (e) {}
                    const isWooUser = $rootScope.user.Stores[0] && $rootScope.user.Stores[0].Type == 3;
                    if (isWooUser) $scope.navigate('/store', true);

                    const previousPath = AuthService.getSignInReturnPath();
                    if (previousPath && !previousPath.includes('subPath')) {
                        $location.path(previousPath);
                    } else {
                        $scope.redirectToHome();
                    }
                    AuthService.setSignInReturnPath(null);
                });
            });
        });

        AuthService.setSignInReturnPath($location.path());
    }
})();
